import { render, staticRenderFns } from "./CreateOrUpdateWebhookSubscription.vue?vue&type=template&id=2dad2199&"
import script from "./CreateOrUpdateWebhookSubscription.vue?vue&type=script&lang=ts&"
export * from "./CreateOrUpdateWebhookSubscription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CreateOrUpdateWebhookSubscription.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports